export const iconFontAwesomeUsersPeopleArrowsDownToPeople = (
	<i className="fa-solid fa-arrows-down-to-people"></i>
);
